/*
  Opens a Postscript SMS popup by id.

  Any element carrying data-postscript-popup="<popup id>" becomes a trigger.
  The listener is delegated, so sections rendered later by the theme editor
  work without re-binding anything.

  Postscript's own script loads asynchronously. Rather than failing on an early
  tap, this waits briefly for it, then falls back to a normal link.
*/
(function () {
  var READY_TIMEOUT = 5000;
  var POLL_INTERVAL = 150;

  /*
    These three options are the difference between a popup that opens and a
    button that appears dead. Without them Postscript silently declines to
    open when the popup is not marked active, when another popup is already
    on screen, or when this visitor has dismissed one recently. A shopper
    tapping "Notify me" has asked for it explicitly, so none of those cooldown
    rules should apply.
  */
  var OPEN_OPTIONS = {
    activePopupBehavior: 'ALWAYS_DISMISS',
    respectPopupStatus: false,
    respectCooldown: false,
  };

  function popupsReady() {
    return (
      window.postscript &&
      window.postscript.popups &&
      typeof window.postscript.popups.open === 'function'
    );
  }

  function openPopup(id, fallbackUrl) {
    var startedAt = Date.now();

    (function attempt() {
      if (popupsReady()) {
        try {
          window.postscript.popups.open(id, OPEN_OPTIONS);
          return;
        } catch (error) {
          console.warn('[postscript] popup failed to open:', error);
        }
      }

      if (Date.now() - startedAt < READY_TIMEOUT) {
        window.setTimeout(attempt, POLL_INTERVAL);
        return;
      }

      console.warn(
        '[postscript] window.postscript never appeared, so the popup could not ' +
          'open. The Postscript app embed has to be enabled for this theme: ' +
          'Online Store, Themes, Customize, App embeds. Enabling the app alone ' +
          'is not enough, the embed is a separate switch.'
      );

      if (fallbackUrl) window.location.href = fallbackUrl;
    })();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-postscript-popup]');
    if (!trigger) return;

    var id = trigger.getAttribute('data-postscript-popup');
    if (!id) return;

    event.preventDefault();

    var fallback =
      trigger.getAttribute('data-postscript-fallback') || trigger.getAttribute('href') || '';

    openPopup(id, fallback === '#' ? '' : fallback);
  });
})();
